import React, { useState, Fragment, useEffect, useRef } from "react";
import { _seCompletePeriodLabel } from "../../../../shared/helpers/streetEasy";
import {
  Button,
  ButtonGroup,
  makeStyles,
  FormControl,
  Box,
  MenuItem,
  Select,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import CalendarRangeIcon from "mdi-react/CalendarRangeIcon";
import CheckIcon from "mdi-react/CheckIcon";
import DateRangeComp from "./DateRangeComp";
import ChevronUpDown from "mdi-react/ChevronUpDownIcon";
import RefreshIcon from "mdi-react/RefreshIcon";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "mdi-react/CloseCircleIcon";

const useStyles = makeStyles((theme) => ({
  select: {
    "& .MuiOutlinedInput-root": {
      minWidth: "160px",
      fontWeight: 600,
      textTransform: "uppercase",
      "&:hover fieldset": {
        borderColor: "#780F9E",
        border: "1px solid",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#780F9E",
        border: "1px solid",
      },
    },

    "& .MuiInputLabel-root": {
      color: "#780F9E",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#780F9E",
    },
    "& .MuiInputBase-input": {
      color: "rgb(92, 97, 120)",
      fontSize: "1rem",
      fontWeight: 600,
      textTransform: "uppercase",
    },
  },
  previousSelect: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // fontSize: "0.875rem",
    width: "350px",
    "& span:nth-child(2)": {
      color: "rgb(92, 97, 120)",
      fontSize: "0.85rem",
      fontWeight: 600,
      textTransform: "uppercase",
    },
  },
  previousCustomSelect: {
    width: "100%",
    color: "#780F9E",
    fontSize: "0.85rem",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  compared: {
    color: "#5C6178",
    fontSize: "0.875rem",
    fontWeight: 400,
  },
  parentBox: {
    display: "flex",
    // justifyContent: "space-between",
    gap: ".3rem",
    position: "relative",
    alignItems: "center",
    "& .MuiOutlinedInput-input": {
      padding: "12px 20px",
      minWidth: 160,
    },
    "& .gap-picker.MuiOutlinedInput-root": {
      minWidth: 0,
      "& .MuiOutlinedInput-input": {
        minWidth: 110,
      },
    },
  },
  checkIcon: {
    marginRight: 8,
    position: "absolute",
    left: "3px",
    color: "#780F9E",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    paddingLeft: "2rem",
    color: "rgb(92, 97, 120)",
    fontSize: "0.85rem",
    fontWeight: 600,
    textTransform: "uppercase",
    padding: "10px 20px",
    "&:hover": {
      backgroundColor: "#EDDEF5",
    },
  },
  selectedMenuItem: {
    backgroundColor: "#EDDEF5",
    color: "#780F9E",
    paddingRight: 0,
    paddingLeft: "2rem",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.85rem",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 999,
  },
  disabled_ele: {
    backgroundColor: "#f0f0f0",
    cursor: "not-allowed",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(192, 192, 192)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgb(192, 192, 192)",
    },
    "& .MuiSelect-root": {
      cursor: "not-allowed",
    },
    "& .MuiInputBase-input": {
      color: "rgb(92, 97, 120)",
      fontSize: "0.85rem",
      fontWeight: 500,
    },
  },
  popupContainer: {
    width: "350px",
    height: "540px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  button: {
    border: "1px solid #ccc",
    height: "auto",
    overflow: "hidden",
    // minHeight: "3.8em",
    textOverflow: "ellipsis",
    textTransform: "none",
    color: "rgb(92, 97, 120)",
    fontSize: "0.85rem",
    minHeight: "3.2em",
    padding: "0 15px",
    fontWeight: 600,
    textTransform: "uppercase",
    "&:hover": {
      border: "2px solid #780F9E",
      backgroundColor: "#fff",
      "& svg": {
        fill: "#780F9E",
      },
    },
  },
  popupButtonClass: {
    border: "2px solid #780F9E",
    "& svg": {
      fill: "#780F9E",
    },
  },
  datePicker: {
    width: "100%",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    padding: "8px",
  },
  submit: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#9600BF",
    margin: "0px 25px",
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
  },
  searchButton: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#5C1F7A !important",
    textTransform: "uppercase  !important",
    fontWeight: "700  !important",
    margin: "0px 5px",
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    minWidth: 120,
    height: 46,
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
    "&.Mui-disabled": {
      boxShadow: "none",
      color: "#9600BF",
      "& svg": {
        fill: "#9600BF",
      },
    },
  },
  dateButton: {
    color: "#FFF",
    border: "none",
    backgroundColor: "#9600BF",
    margin: "0px 5px",
    minWidth: 100,
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    "&.Mui-disabled": {
      "&.selected": {
        backgroundColor: "#5C1F7A",
        color: "#FFF",
      },
    },
  },
}));

const useSlideDateCompStyles = makeStyles((theme) => ({
  slideClass: {
    padding: "10px",
    borderRadius: "10px",
    cursor: "pointer",

    "& .MuiOutlinedInput-root": {
      minWidth: "200px",
      "&:hover fieldset": {
        borderColor: "white",
        border: "1px solid",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
        border: "1px solid",
        color: "#fff",
      },
    },
    "& .MuiInputLabel-root": {
      borderColor: "white",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      borderColor: "white",
      background: "#9600BF",
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
      fontSize: "0.85rem",
      fontWeight: 600,
      textTransform: "uppercase",
      background: "#9600BF",
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    "& $button": {
      height: "auto",
      overflow: "hidden",
      minHeight: "3.2em",
      textOverflow: "ellipsis",
      textTransform: "none",
      color: "#fff",
      fontSize: "0.85rem",
      fontWeight: 500,
      background: "#9600BF",
      border: "none",
      "& svg": {
        fill: "#fff",
      },
      "&:hover": {
        background: "#9600BF",
        border: "1px solid #fff",
        "& svg": {
          fill: "#fff",
        },
      },
    },
  },
  compared: {
    color: "#fff",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
  },
}));
const presetOptions = [
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`${moment().subtract(1, "months").format("MMM YYYY")} (${moment()
          .subtract(1, "months")
          .startOf("month")
          .format("M/D/YYYY")} - ${moment()
          .subtract(1, "months")
          .endOf("month")
          .format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [
      moment().subtract(1, "months").startOf("month"), // Start of last full month
      moment().subtract(1, "months").endOf("month"), // End of last full month
    ],
    gap: "+1MONTH",
  },
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Wk of ${moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .format("MMM Do")} (${moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .format("M/D/YYYY")} - ${moment()
          .subtract(1, "weeks")
          .endOf("isoWeek")
          .format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [
      moment().subtract(1, "weeks").startOf("isoWeek"), // Start of last full week (Monday)
      moment().subtract(1, "weeks").endOf("isoWeek"), // End of last full week (Sunday)
    ],
    gap: "+7DAY",
  },

  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Q${moment().subtract(1, "quarters").quarter()} ${moment()
          .subtract(1, "quarters")
          .year()} (${moment()
          .subtract(1, "quarters")
          .startOf("quarter")
          .format("M/D/YYYY")} - ${moment()
          .subtract(1, "quarters")
          .endOf("quarter")
          .format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [
      moment().subtract(1, "quarters").startOf("quarter"), // Start of last fully completed quarter
      moment().subtract(1, "quarters").endOf("quarter"), // End of last fully completed quarter
    ],
    gap: "+3MONTH",
  },
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Wk to Date (${moment()
          .startOf("isoWeek")
          .format("M/D/YYYY")} - ${moment().format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [moment().startOf("week"), moment()],
    gap: "+7DAY",
  },
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Mo to Date (${moment()
          .startOf("month")
          .format("M/D/YYYY")} - ${moment().format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [moment().startOf("month"), moment()],
    gap: "+1MONTH",
  },
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Qtr to Date (${moment()
          .startOf("quarter")
          .format("M/D/YYYY")} - ${moment().format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [moment().startOf("quarter"), moment()],
    gap: "+3MONTH",
  },
  {
    label: (
      <Fragment>
        <CalendarRangeIcon
          size="18"
          style={{ marginTop: -2 }}
          color="#BF96D9"
        />{" "}
        {`Yr to Date (${moment()
          .startOf("year")
          .format("M/D/YYYY")} - ${moment().format("M/D/YYYY")})`}
      </Fragment>
    ),
    value: [moment().startOf("year"), moment()],
    gap: "+1YEAR",
  },
];
const InputWithTooltipLabel = ({ label, tooltip }) => {
  return null;
  return (
    <Box display="flex" flexDirection="column">
      <Tooltip title={tooltip} placement="top">
        <Typography
          variant="body1"
          component="label"
          style={{
            fontSize: "13px",
            color: "#FFF",
            textAlign: "left",
            cursor: "pointer",
            marginBottom: 5,
            height: 20,
          }}
        >
          {label}
        </Typography>
      </Tooltip>
    </Box>
  );
};

const CustomDateComp = ({
  allowedIntervals,
  gap,
  setDateType,
  setCustomDate,
  customDate,
  calculatePreviousPeriod,
  setFormValues,
  formValues,
  setPreview,
  setParentFetchInProgress,
  setReportData,
  submit,
  setSubmit,
  slideClass = false,
  fetchInProgress,
}) => {
  const classes = useStyles();
  const slideClasses = useSlideDateCompStyles();

  const customLabel = (option) => {
    if (selectedOption === "Custom") {
      if (option.props)
        return option.props.children[2].replace(/\(.*?\)/, "").trim();
      else return option;
    } else {
      return option.props.children[2].replace(/\(.*?\)/, "").trim();
    }
  };
  const filterPresetOptions = () => {
    const { startDate, endDate } = formValues.dateOptions;
    const filteredOptions = presetOptions.filter((option) => {
      const [presetStartDate, presetEndDate] = option.value;
      return (
        moment(startDate).isSame(presetStartDate, "day") &&
        moment(endDate).isSame(presetEndDate, "day")
      );
    });

    if (filteredOptions.length === 0) {
      return "Custom";
    }
    return filteredOptions;
  };

  const matchingOptions = filterPresetOptions();

  const [startDate, setStartDate] = useState(formValues.dateOptions.startDate);
  const [endDate, setEndDate] = useState(formValues.dateOptions.endDate);
  const [selectedOption, setSelectedOption] = useState(
    Array.isArray(matchingOptions)
      ? customLabel(matchingOptions[0].label)
      : matchingOptions
  );
  const [showPopup, setShowPopup] = useState(null);
  const [showPreviousPopup, setShowPreviousPopup] = useState(null);
  const [isStartDateOpen, setIsStartDateOpen] = useState(true);
  const [isPreviousStartDateOpen, setIsPreviousStartDateOpen] = useState(true);
  const popupRef = useRef(null);
  const previousPopUpRef = useRef(null);
  const [selectionGapOption, setSelectedGapOption] = useState(
    formValues.dateOptions.gap
  );
  const [selectedPeriodMode, setSelectedPeriodMode] = useState(
    formValues.dateOptions.periodMode || "current"
  );
  const [currentMonthYear, setCurrentMonthYear] = useState(null);
  const [controlType, setControlType] = useState("simple");

  const [previousCurrentMonthYear, setPreviousCurrentMonthYear] =
    useState(null);
  const [previousDateOptions, setPreviousDateOptions] = useState(
    formValues.dateOptions.isCustomPreviousSelected
      ? {
          value: "Custom",
          label: "Custom",
        }
      : {
          value: [
            formValues.dateOptions.previousStartDate,
            formValues.dateOptions.previousEndDate,
          ],
          label: `Previous Period (${formValues.dateOptions.previousStartDate.format(
            "l"
          )} - ${formValues.dateOptions.previousEndDate.format("l")})`,
        }
  );

  const [previousStartDate, setPreviousStartDate] = useState(
    formValues.dateOptions.isCustomPreviousSelected
      ? formValues.dateOptions.previousStartDate
      : null
  );
  const [previousEndDate, setPreviousEndDate] = useState(
    formValues.dateOptions.isCustomPreviousSelected
      ? formValues.dateOptions.previousEndDate
      : null
  );
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");

  const [previousStartDateError, setPreviousStartDateError] = useState("");
  const [previousEndDateError, setPreviousEndDateError] = useState("");

  useEffect(() => {
    //this condition is because previous date option can have custom value also which is tsring and can open another datepicker
    if (previousDateOptions.value && previousDateOptions.value !== "Custom") {
      let selectPreviousStartDate = previousDateOptions.value[0];
      let selectPreviousEndDate = previousDateOptions.value[1];
      setFormValues((prevState) => ({
        ...prevState,
        dateOptions: {
          ...prevState.dateOptions,
          startDate,
          endDate,
          previousStartDate: selectPreviousStartDate,
          previousEndDate: selectPreviousEndDate,
          gap: selectionGapOption,
        },
      }));
    }

    if (previousStartDate && previousEndDate) {
      setFormValues((prevState) => ({
        ...prevState,
        dateOptions: {
          ...prevState.dateOptions,
          previousStartDate,
          previousEndDate,
        },
      }));
    }
  }, [
    startDate,
    endDate,
    previousDateOptions,
    selectionGapOption,
    previousStartDate,
    previousEndDate,
  ]);
  // setting previous Options on change of startDate & end Date
  useEffect(() => {
    if (
      (startDate &&
        endDate &&
        !formValues.dateOptions.isCustomPreviousSelected &&
        !formValues.dateOptions.isPreviousSelectedClicked) ||
      formValues.dateOptions.isCurrentCustomSelected
    ) {
      if (
        (selectedOption && selectedOption.toUpperCase() === "WK TO DATE") ||
        (selectedOption && selectedOption.toUpperCase().includes("WK OF"))
      ) {
        console.log("helloChintan");
        const previousWeekDetails = calculatePreviousYear52WeeksBack(
          startDate,
          endDate
        );
        console.log(previousWeekDetails, "previousWeekDetails");
        setPreviousDateOptions({
          value: previousWeekDetails[0].value,
          label: previousWeekDetails[0].label.props.children,
        });
      } else {
        const result = calculatePreviousYear(startDate, endDate);
        setPreviousDateOptions({
          value: result[0].value,
          label: result[0].label.props.children,
        });
      }
    }
  }, [
    startDate,
    endDate,
    selectedOption,
    formValues.dateOptions.isCustomPreviousSelected,
    formValues.dateOptions.isPreviousSelectedClicked,
    formValues.dateOptions.isCurrentCustomSelected,
  ]);

  console.log(previousOptions, "previousOption");


  // A report can declare which intervals its data supports (e.g. StreetEasy publishes monthly
  // snapshots, so weekly is not offerable). Absent that, every interval stays available.
  const intervalsLocked = Array.isArray(allowedIntervals) && allowedIntervals.length > 0;
  const ALL_GAP_OPTIONS = [
    { label: "Weekly", value: "+7DAY", interval: "week" },
    { label: "Monthly", value: "+1MONTH", interval: "month" },
    { label: "Quarterly", value: "+3MONTH", interval: "quarter" },
    { label: intervalsLocked ? "Annual" : "Yearly", value: "+1YEAR", interval: "year" },
  ];
  const gapOptions = intervalsLocked
    ? ALL_GAP_OPTIONS.filter((o) => allowedIntervals.indexOf(o.interval) >= 0)
    : ALL_GAP_OPTIONS;
  const allowedGapValues = gapOptions.map((o) => o.value);
  // Presets carry their own gap, so a preset whose interval the report cannot serve is dropped
  // with it — otherwise picking "Last Week" would silently re-introduce a weekly gap.
  const availablePresets = presetOptions.filter((o) => allowedGapValues.indexOf(o.gap) >= 0);
  const CustomOptions = intervalsLocked
    ? availablePresets
    : [{ label: "Custom", value: "Custom" }, ...availablePresets];
  const calculatePreviousDatePeriod = (startDate, endDate) => {
    if (!startDate || !endDate) return [{ label: "", value: [] }];

    const startMonth = startDate.month();
    const endMonth = endDate.month();
    const startQuarter = Math.floor(startMonth / 3);
    const endQuarter = Math.floor(endMonth / 3);
    const dayDifference = endDate.diff(startDate, "days") + 1;
    let adjustedStartDate;
    let adjustedEndDate;
    let label;

    // If the start and end dates are in the same month, but not week-to-date, go 1 month back
    if (startMonth === endMonth || dayDifference === 7) {
      adjustedStartDate = startDate.clone().subtract(1, "months");
      adjustedEndDate = endDate.clone().subtract(1, "months");
      label = `Previous Period (${adjustedStartDate.format(
        "l"
      )} - ${adjustedEndDate.format("l")})`;

      return [
        {
          label: <Fragment>{label}</Fragment>,
          value: [adjustedStartDate, adjustedEndDate],
        },
      ];
    }

    // If the start and end dates cover a quarter, go 1 quarter back
    if (
      startQuarter === endQuarter &&
      endDate.isSame(endDate.clone().endOf("quarter"), "day")
    ) {
      adjustedStartDate = startDate
        .clone()
        .subtract(1, "quarters")
        .startOf("quarter");
      adjustedEndDate = endDate
        .clone()
        .subtract(1, "quarters")
        .endOf("quarter");
      label = `Previous Period (${adjustedStartDate.format(
        "l"
      )} - ${adjustedEndDate.format("l")})`;
      return [
        {
          label: <Fragment>{label}</Fragment>,
          value: [adjustedStartDate, adjustedEndDate],
        },
      ];
    }

    // If the start and end dates span a year, go 1 year back
    if (
      startDate.year() === endDate.year() &&
      endDate.isSame(endDate.clone().endOf("year"), "day")
    ) {
      adjustedStartDate = startDate
        .clone()
        .subtract(1, "years")
        .startOf("year");
      adjustedEndDate = endDate.clone().subtract(1, "years").endOf("year");
      label = `Previous Year (${adjustedStartDate.format(
        "l"
      )} - ${adjustedEndDate.format("l")})`;
      return [
        {
          label: <Fragment>{label}</Fragment>,
          value: [adjustedStartDate, adjustedEndDate],
        },
      ];
    }

    // General fallback for periods with different start and end months

    adjustedStartDate = startDate.clone().subtract(dayDifference, "days");
    adjustedEndDate = endDate.clone().subtract(dayDifference, "days");
    label = `Previous Year (${adjustedStartDate.format(
      "l"
    )} - ${adjustedEndDate.format("l")})`;

    return [
      {
        label: <Fragment>{label}</Fragment>,
        value: [adjustedStartDate, adjustedEndDate],
      },
    ];
  };

  const calculatePreviousYear52WeeksBack = (startDate, endDate) => {
    if (!startDate || !endDate) return [{ label: "", value: [] }];
    const adjustedStartDate = startDate
      .clone()
      .subtract(52, "weeks")
      .startOf("isoWeek");
      const adjustedEndDate = adjustedStartDate.clone().endOf("isoWeek");
    const label = `Previous Year (${adjustedStartDate.format(
      "l"
    )} - ${adjustedEndDate.format("l")})`;

    // Returning the adjusted range
    return [
      {
        label: <Fragment>{label}</Fragment>,
        value: [adjustedStartDate, adjustedEndDate],
      },
    ];
  };
  const calculatePreviousYear = (startDate, endDate) => {
    if (!startDate || !endDate) return [{ label: "", value: [] }];

    const startMonth = startDate.month();
    const endMonth = endDate.month();
    let adjustedStartDate;
    let adjustedEndDate;
    let label;
    adjustedStartDate = startDate.clone().subtract(1, "years");

    adjustedEndDate = endDate.clone().subtract(1, "years");
    label = `Previous Year (${adjustedStartDate.format(
      "l"
    )} - ${adjustedEndDate.format("l")})`;
    return [
      {
        label: <Fragment>{label}</Fragment>,
        value: [adjustedStartDate, adjustedEndDate],
      },
    ];
  };
  const getLabelForValue = (value) => {
    const selectedOption = gapOptions.find((option) => option.value === value);
    console.log(gapOptions,selectedOption, "selectedOption")
    return selectedOption ? selectedOption.label : "SELECT COMPARATOR";
  };
  const calculatePreviousWeeklyDatePeriod = (startDate, endDate) => {
    if (!startDate || !endDate) return [{ label: "", value: [] }];
    let adjustedStartDate;
    let adjustedEndDate;

    if (
      (selectedOption && selectedOption.toUpperCase() === "WK TO DATE") ||
      (selectedOption && selectedOption.toUpperCase().includes("WK OF"))
    ) {
      adjustedStartDate = startDate
        .clone()
        .subtract(1, "weeks")
        .startOf("week");
      adjustedEndDate = startDate.clone().subtract(1, "weeks").endOf("week");
    } else {
      adjustedStartDate = startDate.clone().subtract(1, "weeks");
      adjustedEndDate = endDate.clone().subtract(1, "weeks");
    }

    const label = `Previous Week (${adjustedStartDate.format(
      "l"
    )} - ${adjustedEndDate.format("l")})`;

    return [
      {
        label: <Fragment>{label}</Fragment>,
        value: [adjustedStartDate, adjustedEndDate],
      },
    ];
  };

  const previousOptions = [
    ...(selectedOption &&
    (selectedOption.toUpperCase() === "WK TO DATE" ||
      selectedOption.toUpperCase().includes("WK OF"))
      ? calculatePreviousWeeklyDatePeriod(startDate, endDate)
      : [{ label: "", value: [] }]),
    ...calculatePreviousDatePeriod(startDate, endDate),
    ...(selectedOption &&
    (selectedOption.toUpperCase() === "WK TO DATE" ||
      selectedOption.toUpperCase().includes("WK OF"))
      ? calculatePreviousYear52WeeksBack(startDate, endDate)
      : calculatePreviousYear(startDate, endDate)),
  ];

  const handlePreviousOptionChange = (event) => {
    const selectedOption = event.target.value;

    // Update the state with the selected option's label and value
    setPreviousDateOptions({
      value: selectedOption.value,
      label: selectedOption.label,
    });
    if (selectedOption.label !== "Custom") {
      setPreviousStartDate(null);
      setPreviousEndDate(null);
    }
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        isCustomPreviousSelected: false,
        isPreviousSelectedClicked: true,
        anyChangeOccured: true,
      },
    }));
  };
  const handleDatePicker = (event) => {
    setShowPopup(event.target);
    setIsStartDateOpen(true); // Ensure the start date picker is open by default
  };
  const handlePreviousDatePicker = (event) => {
    setShowPreviousPopup(event.target);
    setIsPreviousStartDateOpen(true); // Ensure the start date picker is open by default
  };

  const handleClose = () => {
    setShowPopup(null);
  };
  const handlePreviousClose = () => {
    setShowPreviousPopup(null);
  };

  const submitHandler = () => {
    setSubmit(true);
    setParentFetchInProgress(false);
    setReportData(null);
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        anyChangeOccured: false,
      },
    }));
    setPreview();
  };
  // const isCustomSelected = !predefinedGaps.includes(gap);

  // Custom rendering logic to remove the date range and show only the main label
  const customPreviousLabel = (option) => {
    if (option.props) {
      return option.props.children;
    } else return "";
  };
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue.label);
    setStartDate(selectedValue.value[0]);
    setEndDate(selectedValue.value[1]);
    setPreviousStartDate(null);
    setPreviousEndDate(null);
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        isCustomPreviousSelected: false,
        isPreviousSelectedClicked: false,
        anyChangeOccured: true,
      },
    }));
  };

  const handleGapChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedGapOption(selectedValue.value);
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        anyChangeOccured: true,
      },
    }));
  };
  const disabledClass = () => {
    if (!startDate && !endDate) return classes.disabled_ele;
    else return classes.select;
  };
  const extractDateRangeUsingSplit = (inputString) => {
    const parts = inputString.split(/[()]/);
    return parts[1] ? parts[1].trim() : null;
  };

  const handlePresetSelect = (selectedValue) => {
    setSelectedOption(customLabel(selectedValue.label));
    setStartDate(selectedValue.value[0]);
    setEndDate(selectedValue.value[1]);
    setPreviousStartDate(null);
    setPreviousEndDate(null);
    setSelectedGapOption(selectedValue.gap);
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        isCustomPreviousSelected: false,
        isPreviousSelectedClicked: false,
        anyChangeOccured: true,
      },
    }));

    // Call submitHandler after a delay of 1000 milliseconds (1 second)
    setTimeout(() => {
      submitHandler();
    }, 300);
  };

  const handleAdvancedModeToggle = () => {
    setControlType((prev) => (prev === "simple" ? "advanced" : "simple"));
    if (
      formValues &&
      formValues.dateOptions &&
      formValues.dateOptions.anyChangeOccured
    ) {
      submitHandler();
    }
  };

  const ControlType = () => {
    return (
      <div
        style={{
          display: "inline-block",
          borderRadius: "50%",
          width: 26,
          height: 26,
          background: "#FFF",
        }}
      >
        <CloseIcon
          onClick={handleAdvancedModeToggle}
          size={32}
          style={{ marginTop: -3, marginLeft: -3 }}
          color={"#9600BF"}
        />
      </div>
    );
  };

  // Locked reports get one button per supported interval and nothing else — no date-range
  // presets and no "More.." into the advanced panel, both of which offer periods the data cannot
  // answer. Writes `gap` straight into formValues rather than relying on the date-sync effect,
  // since nothing else about the range changes here.
  const selectInterval = (option) => {
    setSelectedGapOption(option.value);
    setSelectedPeriodMode(option.periodMode || "current");
    setFormValues((prev) => ({
      ...prev,
      dateOptions: {
        ...prev.dateOptions,
        gap: option.value,
        periodMode: option.periodMode || "current",
        anyChangeOccured: true,
      },
    }));
    // Same hand-off the date presets use: submitHandler clears reportData and sets submit, which
    // is what actually re-runs the report. The short delay lets the formValues update settle so
    // loadData reads the new gap rather than the previous one.
    setTimeout(() => {
      submitHandler();
    }, 300);
  };

  if (controlType == "simple" && intervalsLocked) {
    // Quarter and year each offer a to-date period and the last completed one — "where are we
    // now" and "what did the last full period do" are different questions.
    const periodButtons = [];
    gapOptions.forEach((option) => {
      if (option.interval === "month") {
        periodButtons.push({ ...option, periodMode: "current", label: "Monthly" });
        return;
      }
      periodButtons.push({
        ...option,
        periodMode: "current",
        label: option.interval === "quarter" ? "QTD" : "YTD",
      });
      periodButtons.push({
        ...option,
        periodMode: "complete",
        label: _seCompletePeriodLabel(option.interval),
      });
    });

    return (
      <div className="mt-3 mb-2">
        <div>
          {periodButtons.map((option) => {
            const active =
              selectionGapOption === option.value && selectedPeriodMode === option.periodMode;
            return (
            <Button
              key={option.value + option.periodMode}
              onClick={() => selectInterval(option)}
              disabled={active || fetchInProgress}
              className={`${classes.dateButton} ${active ? "selected" : ""}`}
            >
              {option.label}
            </Button>
            );
          })}
        </div>
      </div>
    );
  }

  if (controlType == "simple") {
    return (
      <div className="mt-3 mb-2">
        <div>
          {availablePresets.map((item, index) => (
            <Button
              key={index}
              onClick={() => handlePresetSelect(item)}
              disabled={
                selectedOption === customLabel(item.label) || fetchInProgress
              }
              className={`${classes.dateButton} ${
                selectedOption === customLabel(item.label) ? "selected" : ""
              }`}
            >
              {customLabel(item.label)}
            </Button>
          ))}
          <Button
            key={"more"}
            onClick={handleAdvancedModeToggle}
            className={`${classes.dateButton}`}
            startIcon={<CalendarRangeIcon size={16} />}
            disabled={fetchInProgress}
          >
            More..
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div
      className={`${classes.parentBox} ${
        slideClass ? slideClasses.slideClass : ""
      }`}
    >
      {/* With intervals locked the report always shows the newest complete period, so a preset
          range, a custom range and a hand-picked comparison period have nothing to act on — the
          interval below is the whole control. */}
      {intervalsLocked ? null : (
      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel
          label={"Report Date"}
          tooltip={"Fitler the date range that the report should analyze"}
        />
        <Select
          value={selectedOption}
          displayEmpty
          variant="outlined"
          renderValue={() => selectedOption || "SELECT RANGE"}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
          }}
        >
          {(selectedOption === "Custom" ? CustomOptions : availablePresets).map(
            (item) => (
              <MenuItem
                key={customLabel(item.label)}
                value={{ value: item.value, label: customLabel(item.label) }}
                className={
                  selectedOption === customLabel(item.label)
                    ? classes.selectedMenuItem
                    : classes.menuItem
                }
              >
                {selectedOption === customLabel(item.label) ? (
                  <CheckIcon className={classes.checkIcon} />
                ) : null}
                {customLabel(item.label)}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
      )}
      {intervalsLocked ? null : (
      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel
          label={"Date Range"}
          tooltip={
            "Chose custom dates if predefined date does not meet your needs"
          }
        />
        <Button
          className={`${classes.button} ${
            showPopup ? classes.popupButtonClass : ""
          }`}
          onClick={handleDatePicker}
          disableRipple
        >
          <CalendarRangeIcon
            size="18"
            style={{ marginRight: 8 }}
            color="#BF96D9"
          />
          {startDate && endDate ? (
            <span>
              {moment(startDate).format("l")} - {moment(endDate).format("l")}
            </span>
          ) : (
            "Select Date"
          )}
        </Button>
      </FormControl>
      )}
      {intervalsLocked ? null : (
      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel label={""} tooltip={""} />
        <Box
          className={` ${
            slideClass ? slideClasses.compared : classes.compared
          }`}
        >
          vs.
        </Box>
      </FormControl>
      )}
      {intervalsLocked ? null : (
      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel
          label={"Comparison Date"}
          tooltip={"Select a date range to compare against"}
        />
        <Select
          value={previousDateOptions}
          displayEmpty
          variant="outlined"
          renderValue={() => {
            if (previousDateOptions.value.length === 2) {
              const startDate = moment(previousDateOptions.value[0]).format(
                "l"
              );
              const endDate = moment(previousDateOptions.value[1]).format("l");
              return `${startDate} - ${endDate}`;
            } else if (previousDateOptions.value === "Custom") {
              return "Custom";
            }
            return "SELECT PREVIOUS RANGE"; // Default placeholder when no option is selected
          }}
          disabled={startDate && endDate ? false : true}
          onChange={handlePreviousOptionChange}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
          }}
        >
          {previousOptions.map((item) => {
            {console.log(item, "helloItem")}
            const data = customPreviousLabel(item.label).split("(");
            const isSelected =
              previousDateOptions.label &&
              extractDateRangeUsingSplit(previousDateOptions.label) ===
                extractDateRangeUsingSplit(customPreviousLabel(item.label));
                if (!item.label) return null
            return (
              <MenuItem
              key={customPreviousLabel(item.label)}
              value={{
                value: item.value,
                label: customPreviousLabel(item.label),
              }}
              className={
                isSelected ? classes.selectedMenuItem : classes.menuItem
              }
            >
              {isSelected && <CheckIcon className={classes.checkIcon} />}

              {data.length > 1 && (
                <div className={classes.previousSelect}>
                  <span style={{ color: "#780F9E", fontWeight: 600 }}>
                    {data[0]}
                  </span>{" "}
                  <span>{data[1].replace(")", "")}</span>
                </div>
              )}
            </MenuItem>
            );
          })}

          {startDate && endDate ? (
            <MenuItem
              value={{
                value: "Custom",
                label: "Custom",
              }}
              className={`${classes.previousSelect} ${
                classes.previousCustomSelect
              } ${
                previousDateOptions.label === "Custom"
                  ? classes.selectedMenuItem
                  : classes.menuItem
              }`}
            >
              {!intervalsLocked && previousDateOptions.label === "Custom" ? (
                <CheckIcon className={classes.checkIcon} />
              ) : null}
              Custom
            </MenuItem>
          ) : null}
        </Select>
      </FormControl>
      )}
      {!intervalsLocked && previousDateOptions.label === "Custom" ? (
        <FormControl className={disabledClass()}>
          <InputWithTooltipLabel
            label={"Custom Date"}
            tooltip={"Select custom date to compare against"}
          />
          <Button
            className={`${classes.button} ${
              showPreviousPopup ? classes.popupButtonClass : ""
            } ${disabledClass()}`}
            onClick={handlePreviousDatePicker}
            disableRipple
          >
            <CalendarRangeIcon
              size="18"
              style={{ marginRight: 8 }}
              color="#BF96D9"
            />
            {previousStartDate && previousEndDate ? (
              <span>
                {previousStartDate ? moment(previousStartDate).format("l") : ""}{" "}
                - {previousEndDate ? moment(previousEndDate).format("l") : ""}
              </span>
            ) : (
              "Select Custom Date"
            )}
          </Button>
        </FormControl>
      ) : null}
      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel
          label={"Chart Granularity"}
          tooltip={"Define the level of detail in charts"}
        />
        <Select
          IconComponent={ChevronUpDown}
          value={selectionGapOption}
          displayEmpty
          disabled={startDate && endDate ? false : true}
          renderValue={() => getLabelForValue(selectionGapOption)}
          onChange={handleGapChange}
          variant="outlined"
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
          }}
          className="gap-picker"
        >
          {gapOptions.map((item) => (
            <MenuItem
              key={item.label}
              value={{ value: item.value, label: item.label }}
              className={
                selectionGapOption === item.value
                  ? classes.selectedMenuItem
                  : classes.menuItem
              }
            >
              {selectionGapOption === item.value ? (
                <CheckIcon className={classes.checkIcon} />
              ) : null}
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={disabledClass()}>
        <InputWithTooltipLabel label={" "} tooltip={""} />
        <Tooltip title={"Rewrite report with the updated dates"}>
          <Button
            startIcon={<RefreshIcon />}
            className={classes.searchButton}
            onClick={submitHandler}
            disabled={!formValues.dateOptions.anyChangeOccured}
          >
            Update
          </Button>
        </Tooltip>
      </FormControl>
      <Popover
        id={showPopup ? "simple-popover" : undefined}
        open={Boolean(showPopup)}
        anchorEl={showPopup}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box ref={popupRef} className={classes.popupContainer}>
          <DateRangeComp
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            setIsStartDateOpen={setIsStartDateOpen}
            isStartDateOpen={isStartDateOpen}
            setCurrentMonthYear={setCurrentMonthYear}
            currentMonthYear={currentMonthYear}
            setSelectedOption={setSelectedOption}
            setCurrentFormValues={setFormValues}
            setStartDateError={setStartDateError}
            setEndDateError={setEndDateError}
            startDateError={startDateError}
            endDateError={endDateError}
            setCurentFormValues={setFormValues}
          />
        </Box>
      </Popover>
      <Popover
        id={showPreviousPopup ? "simple-popover" : undefined}
        open={Boolean(showPreviousPopup)}
        anchorEl={showPreviousPopup}
        onClose={handlePreviousClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box ref={previousPopUpRef} className={classes.popupContainer}>
          <DateRangeComp
            startDate={previousStartDate}
            endDate={previousEndDate}
            setStartDate={setPreviousStartDate}
            setEndDate={setPreviousEndDate}
            showPopup={showPreviousPopup}
            setShowPopup={setShowPreviousPopup}
            setIsStartDateOpen={setIsPreviousStartDateOpen}
            isStartDateOpen={isPreviousStartDateOpen}
            setCurrentMonthYear={setPreviousCurrentMonthYear}
            currentMonthYear={previousCurrentMonthYear}
            setFormValues={setFormValues}
            setStartDateError={setPreviousStartDateError}
            setEndDateError={setPreviousEndDateError}
            startDateError={previousStartDateError}
            endDateError={previousEndDateError}
          />
        </Box>
      </Popover>
      <ControlType />
    </div>
  );
};

export default CustomDateComp;
